<div
   mat-dialog-title
   class="app-dialog-title"
>
   <div>{{ 'privacy_statement' | translate }}</div>
   <mat-icon mat-dialog-close>close</mat-icon>
</div>
<div
   mat-dialog-content
   class="bg-app-light-gray"
>
   <div
      class="dialog-body privacy-statement-dialog-body"
      style="padding: 10px !important"
   >
      <p
         class="dialog-row"
         [innerHTML]="data.innerHTML"
      ></p>

      <p class="dialog-row">
         <mat-checkbox
            class="example-margin"
            [formControl]="acceptCheckbox"
            >Accept</mat-checkbox
         >
      </p>
   </div>
</div>

<div
   mat-dialog-actions
   class="flex flex-row justify-end gap-4 border-t border-app-gray-2"
>
   <p-button
      styleClass="basic-accent-1-button h-[45px] w-[120px] flex flex-row items-center justify-center"
      type="submit"
      [mat-dialog-close]="true"
      [disabled]="checkboxValidation()"
      (click)="preferenceChange()"
      [label]="'confirm' | translate"
   >
   </p-button>

   <p-button
      styleClass="basic-accent-2-button h-[45px] w-[120px] flex flex-row items-center justify-center"
      [mat-dialog-close]="true"
      mat-dialog-close
      cdkFocusInitial
      [label]="'close' | translate"
   >
   </p-button>
</div>
